<template>
  <el-container style="height: 929px; position: relative">
    <el-header
      style="
        margin-top: 10px;
        padding-left: 20px;
        margin-left: 40px;
        margin-right: 34px;
        margin-bottom: 10px;
        background-color: #e8ebf7;
      "
    >
      <el-row type="flex" align="middle" justify="space-between">
        <div
          style="
            font-weight: bold;
            font-size: 20px;
            color: #983cc9;
            margin-top: 5px;
          "
        >
          DxAI 智医-报告解读工具
        </div>

        <el-dropdown style="margin-top: 10px">
          <span>
            <el-avatar
              src="https://cube.elemecdn.com/0/88/03b0d39583f48206768a7534e55bcpng.png"
            />
            <el-icon class="el-icon--right">
              <arrow-down />
            </el-icon>
          </span>
          <template #dropdown>
            <el-dropdown-menu style="position: relative; z-index: 9999">
              <el-dropdown-item>
                <span style="display: block; width: 100%" @click="handleProfile"
                  >个人中心</span
                >
              </el-dropdown-item>
              <el-dropdown-item>
                <span style="display: block; width: 100%" @click="handleOut"
                  >退出登录</span
                >
              </el-dropdown-item>
            </el-dropdown-menu>
          </template>
        </el-dropdown>
      </el-row>
    </el-header>
    <el-container style="height: 850px; width: 100%">
      <el-aside width="280px">
        <el-card style="height: 696px; overflow-y: auto" class="menu">
          <el-menu :default-active="defaultActive" router>
            <el-submenu index="1">
              <template slot="title">
                <span>后台管理</span>
              </template>
              <el-menu-item
                v-show="item.is_show || item.is_superuser == is_superuser"
                :index="item.path"
                v-for="(item, index) in menuList"
                :key="item.label"
                v-if="!item.isSubmenu"
              >
                <i :class="item.icon"></i>
                <span slot="title">{{ item.label }}</span>
              </el-menu-item>

              <!-- 影响因素子菜单 -->
              <el-submenu index="2">
                <template slot="title">
                  <i class="el-icon-s-opportunity"></i>
                  <span>影响因素</span>
                </template>
                <el-menu-item
                  v-for="(item, index) in influenceMenuList"
                  :key="item.label"
                  :index="item.path"
                  v-show="item.is_show || item.is_superuser == is_superuser"
                >
                  <i :class="item.icon"></i>
                  <span slot="title">{{ item.label }}</span>
                </el-menu-item>
              </el-submenu>

              <!-- 检验仪器子菜单 -->
              <el-submenu index="3">
                <template slot="title">
                  <i class="el-icon-s-opportunity"></i>
                  <span>检验仪器</span>
                </template>
                <el-menu-item
                  v-for="(item, index) in TestMenuList"
                  :key="item.label"
                  :index="item.path"
                  v-show="item.is_show || item.is_superuser == is_superuser"
                >
                  <i :class="item.icon"></i>
                  <span slot="title">{{ item.label }}</span>
                </el-menu-item>
              </el-submenu>

              <!-- 第二组菜单项 -->
              <el-menu-item
                v-show="item.is_show || item.is_superuser == is_superuser"
                :index="item.path"
                v-for="(item, index) in MunuList2"
                :key="item.label"
              >
                <i :class="item.icon"></i>
                <span slot="title">{{ item.label }}</span>
              </el-menu-item>
            </el-submenu>
          </el-menu>
        </el-card>
      </el-aside>
      <el-main style="padding: 0 20px 40px 0px">
        <router-view />
      </el-main>
    </el-container>
  </el-container>
</template>

<script>
import AppHeader from "@/public/app-header.vue";
import api from "@/api/index";
import router from "@/router";

export default {
  name: "LayoutView",
  components: {
    AppHeader,
  },
  data() {
    return {
      defaultActive: "/bec/static",
      menuList: [
        {
          label: "数据统计",
          path: "/bec/static",
          icon: "el-icon-s-data",
          is_show: true,
          isSubmenu: false,
        },
        {
          label: "单位管理",
          path: "/bec/region",
          icon: "el-icon-s-platform",
          is_show: true,
          isSubmenu: false,
        },
        {
          label: "用户管理",
          path: "/bec/admin",
          icon: "el-icon-s-custom",
          is_show: true,
          isSubmenu: false,
        },
        {
          label: "模型管理",
          path: "/bec/model",
          icon: "el-icon-s-opportunity",
          is_superuser: 2,
          isSubmenu: false,
        },
        {
          label: "脱敏规则管理",
          path: "/bec/desensitization",
          icon: "el-icon-s-opportunity",
          is_superuser: 2,
          isSubmenu: false,
        },
        {
          label: "提示词管理",
          path: "/bec/cue/word",
          icon: "el-icon-s-opportunity",
          is_superuser: 2,
          isSubmenu: false,
        },
        {
          label: "智能向导",
          path: "/bec/intelligent/wizard",
          icon: "el-icon-s-opportunity",
          is_superuser: 2,
          isSubmenu: false,
        },
      ],
      influenceMenuList: [
        {
          label: "影响因素编辑",
          path: "/bec/influence/factor",
          icon: "el-icon-s-opportunity",
          is_show: true,
        },
        {
          label: "影响因素字典",
          path: "/bec/influence/dictionary",
          icon: "el-icon-s-opportunity",
          is_superuser: 2,
        },
      ],
      TestMenuList: [
        {
          label: "检验平台编辑",
          path: "/bec/testing/instruments",
          icon: "el-icon-s-opportunity",
          is_show: true,
          isSubmenu: false,
        },
        {
          label: "检验仪器字典",
          path: "/bec/testing/dictionary",
          icon: "el-icon-s-opportunity",
          is_superuser: 2,
          isSubmenu: false,
        },
      ],
      MunuList2: [
        {
          label: "疾病类型字典",
          path: "/bec/disease",
          icon: "el-icon-s-opportunity",
          is_superuser: 2,
          isSubmenu: false,
        },
        {
          label: "更新通告管理",
          path: "/bec/update_notice",
          icon: "el-icon-s-opportunity",
          is_superuser: 2,
          isSubmenu: false,
        },
      ],
      is_superuser: 1,
    };
  },
  mounted() {
    this.defaultActive = this.$route.path;
    this.getUserInfo();
    this.is_superuser = JSON.parse(
      localStorage.getItem("userinfo")
    ).is_superuser;
  },
  activated() {
    console.log("activated");

    this.defaultActive = this.$route.path;
    this.getUserInfo();
    this.is_superuser = JSON.parse(
      localStorage.getItem("userinfo")
    ).is_superuser;
  },
  methods: {
    handleProfile() {
      this.defaultActive = "";
      this.$router.push("/bec/user/info");
    },
    handleOut() {
      localStorage.removeItem("userinfo");
      this.$router.push("/admin/login");
    },
    getUserInfo() {
      api.chat.userDetail().then((res) => {
        if (res.code == 500) {
          this.$message.error(res.error);
          this.$router.push("/admin/login");
          return;
        } else if (res.code == 200) {
          localStorage.setItem("userinfo", JSON.stringify(res.info));
        }
      });
    },
  },
};
</script>

<style scoped>
.el-header {
  padding: 0;
}

.el-aside {
  height: 920px;
  padding: 0px 10px 40px 40px;
}

.el-main {
  height: 920px;
}

.menu :deep(.el-card__body) {
  padding: 0 !important;
}

:deep(.el-card) {
  border-radius: 0 !important;
}

.el-menu {
  border-right: none;
}

/* 只给第一层子菜单添加样式 */
:deep(.el-menu .el-submenu:first-child > .el-submenu__title) {
  background-color: #983cc9 !important;
  color: white !important;
  font-weight: bold;
  font-size: 18px;
}

/* 隐藏第一层子菜单的箭头 */
:deep(
    .el-menu
      .el-submenu:first-child
      > .el-submenu__title
      .el-submenu__icon-arrow
  ) {
  display: none !important;
}

/* 恢复内部子菜单的默认样式 */
:deep(.el-menu .el-submenu .el-submenu .el-submenu__title) {
  background-color: #fff !important;
  color: #303133 !important;
  font-weight: normal !important;
  font-size: 14px !important;
}

/* 显示内部子菜单的箭头 */
:deep(
    .el-menu .el-submenu .el-submenu .el-submenu__title .el-submenu__icon-arrow
  ) {
  display: inline-block !important;
}
</style>
